'use strict';
var _ = require('underscore');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');

var PreferenceView = require('./list-item').default;
var PreferenceCollection = require('../../collections/preferences').default;

export default Marionette.View.extend({

  className: 'preference-list',
  tagName: 'ul',

  initialize: function (options) {
    this.collection = options.collection;
    this.prefs = [];
    this.service_duration = options.service_duration;

    this.listenTo(Radio.channel('list'), 'removePreference', this.onRemovePreference);
  },

  addPreference: function (model) {
    var prefView = new PreferenceView({ model, index: this.prefs.length });
    this.prefs.push(prefView);
    if (!model) {
      this.collection.push(prefView.model);
    }

    this.renderPreference(prefView);
    this.checkIfShouldDisableClear();
  },

  onRemovePreference: function (view) {
    this.prefs = this.prefs.filter(current => current !== view);
    this.collection.remove(view.model);
    this.checkIfShouldDisableClear();
    view.destroy();
  },
  
  getPreferenceCollection: function () {
    var self = this;
    var preferences = new PreferenceCollection();
    _.each(this.prefs, function (pref) {
      var model = pref.getModel();
      model.service_duration = self.service_duration;
      preferences.push(model);
    });

    return preferences;
  },

  render: function () {
    this.$el.empty();
    if (this.collection.length) {
      var boundAddPreference = this.addPreference.bind(this);
      this.collection.each((model) => {
        boundAddPreference(model)
      });
    } else {
      this.addPreference();
    }

    return this;
  },

  checkIfShouldDisableClear: function () {
    if (this.prefs.length === 1) {
      this.prefs[0].disableClearButton();
    } else {
      this.prefs[0].enableClearButton();
    }
  },

  renderPreference: function (pref) {
    this.$el.append(pref.render().el);
  },

});
